// client/src/coms/stickers/stickerSuggestPrefs.js
// Settings → Stickers → "Suggest stickers while typing" (on by default, stored per device).
import { useEffect, useState } from 'react';

export const LS_STICKER_SUGGESTIONS = 'vox:stickerSuggestions';
export const STICKER_SUGGESTIONS_EVENT = 'vox-sticker-suggestions-changed';

export function readStickerSuggestionsEnabled() {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return true;
    return window.localStorage.getItem(LS_STICKER_SUGGESTIONS) !== '0';
  } catch {
    return true;
  }
}

export function writeStickerSuggestionsEnabled(enabled) {
  const next = !!enabled;
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      if (next) window.localStorage.removeItem(LS_STICKER_SUGGESTIONS);
      else window.localStorage.setItem(LS_STICKER_SUGGESTIONS, '0');
    }
  } catch {}
  try {
    window.dispatchEvent(new CustomEvent(STICKER_SUGGESTIONS_EVENT, { detail: { enabled: next } }));
  } catch {}
  return next;
}

// Updates live when changed in Settings or in another tab.
export default function useStickerSuggestionsEnabled() {
  const [enabled, setEnabled] = useState(() => readStickerSuggestionsEnabled());
  useEffect(() => {
    const onChanged = (e) => setEnabled(e && e.detail && typeof e.detail.enabled === 'boolean' ? e.detail.enabled : readStickerSuggestionsEnabled());
    const onStorage = (e) => {
      if (!e || e.key === LS_STICKER_SUGGESTIONS || e.key === null) setEnabled(readStickerSuggestionsEnabled());
    };
    window.addEventListener(STICKER_SUGGESTIONS_EVENT, onChanged);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(STICKER_SUGGESTIONS_EVENT, onChanged);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return enabled;
}
